export default "__VITE_ASSET__16634ba1__"